var map = {
	"./": 36,
	"./App": 48,
	"./App.css": 90,
	"./App.js": 48,
	"./components/Cart/Cart": 58,
	"./components/Cart/Cart.js": 58,
	"./components/Cart/Cart.module.css": 3,
	"./components/Cart/CartTotal/CartTotal": 59,
	"./components/Cart/CartTotal/CartTotal.js": 59,
	"./components/Cart/CartTotal/CartTotal.module.css": 19,
	"./components/Cart/Carts": 61,
	"./components/Cart/Carts.js": 61,
	"./components/Navigation/HamBurgerMenu/HamBurgermenu": 53,
	"./components/Navigation/HamBurgerMenu/HamBurgermenu.js": 53,
	"./components/Navigation/HamBurgerMenu/HamBurgermenu.module.css": 83,
	"./components/Navigation/NavigationItem": 30,
	"./components/Navigation/NavigationItem.js": 30,
	"./components/Navigation/NavigationItem.module.css": 65,
	"./components/Navigation/NavigationItems": 25,
	"./components/Navigation/NavigationItems.js": 25,
	"./components/Navigation/NavigationItems.module.css": 32,
	"./components/Navigation/SideBar/SideBar": 54,
	"./components/Navigation/SideBar/SideBar.js": 54,
	"./components/Navigation/SideBar/SideBar.module.css": 33,
	"./components/Navigation/Toolbar/ToolBar": 51,
	"./components/Navigation/Toolbar/ToolBar.js": 51,
	"./components/Navigation/Toolbar/Toolbar.module.css": 66,
	"./components/Payment/PaypalButton": 60,
	"./components/Payment/PaypalButton.js": 60,
	"./components/Product/Product": 57,
	"./components/Product/Product.js": 57,
	"./components/Product/Product.module.css": 8,
	"./components/Product/Products": 55,
	"./components/Product/Products.js": 55,
	"./components/Product/Products.module.css": 67,
	"./components/ProductDetail/Details": 62,
	"./components/ProductDetail/Details.js": 62,
	"./components/ProductDetail/Details.module.css": 17,
	"./components/Summary/CartAdded/CartAddedSummary": 27,
	"./components/Summary/CartAdded/CartAddedSummary.js": 27,
	"./components/Summary/CartAdded/CartAddedSummary.module.css": 35,
	"./components/UI/BackDrop/BackDrop": 63,
	"./components/UI/BackDrop/BackDrop.js": 63,
	"./components/UI/BackDrop/BackDrop.module.css": 84,
	"./components/UI/Button/Button": 13,
	"./components/UI/Button/Button.js": 13,
	"./components/UI/Button/Button.module.css": 68,
	"./components/UI/Modal/Modal": 26,
	"./components/UI/Modal/Modal.js": 26,
	"./components/UI/Modal/Modal.module.css": 34,
	"./components/UI/NotFound/PageNotFound": 49,
	"./components/UI/NotFound/PageNotFound.js": 49,
	"./components/UI/logo/Logo": 52,
	"./components/UI/logo/Logo.js": 52,
	"./components/context/ProductContext": 11,
	"./components/context/ProductContext.js": 11,
	"./components/layout/Layout": 50,
	"./components/layout/Layout.js": 50,
	"./data": 56,
	"./data.js": 56,
	"./img/logo1.jpg": 82,
	"./img/product-1.png": 148,
	"./img/product-2.png": 149,
	"./img/product-3.png": 150,
	"./img/product-4.png": 151,
	"./img/product-5.png": 152,
	"./img/product-6.png": 153,
	"./img/product-7.png": 154,
	"./img/product-8.png": 155,
	"./index": 36,
	"./index.css": 89,
	"./index.js": 36,
	"./logo.svg": 156,
	"./serviceWorker": 93,
	"./serviceWorker.js": 93,
	"./setupTests": 94,
	"./setupTests.js": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;